import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "error", "id", "name", "warning", "excludeInput"],
  _excluded2 = ["onPressIn", "onPressOut"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import View from '@bubble-ui/primitive-view';
import Touchable from '@bubble-ui/primitive-touchable';
import { useDesignContext } from '@klarna/designtokens';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { useInteractiveStateCombined } from '@bubble-ui/hook-use-interactive-state';
import { isNative } from '@bubble-ui/util-platform';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var RadioBullet = _ref => {
  var {
      checked,
      error,
      id,
      name,
      warning,
      excludeInput
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var ids = getIds(id);
  var designContext = useDesignContext(defaultDesignTokens);
  var designVersion = useDesignVersion();
  var [interactiveStateCombined, _ref2] = useInteractiveStateCombined(props);

  // excludeInput is by default "true" in native and "false" in web
  var {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onPressIn,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onPressOut
    } = _ref2,
    eventHandlers = _objectWithoutProperties(_ref2, _excluded2);
  var defaultValueOfExcludeInput = Boolean(isNative);
  var platformDependentExcludeInput = excludeInput !== undefined ? excludeInput : defaultValueOfExcludeInput;
  var {
    wrapperStyle,
    borderStyle,
    innerCircleStyle,
    overflowingCircleStyle,
    solidColorStyle,
    inputStyle
    // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
    // Keep passing all props to the style sheet, even if we don't use them ourselves
  } = useStyleSheet(RadioBullet, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    checked,
    designContext,
    designVersion,
    error,
    excludeInput,
    id,
    name,
    warning
  }, interactiveStateCombined));
  return /*#__PURE__*/React.createElement(View, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    style: wrapperStyle
  }, eventHandlers), isNative === false && !platformDependentExcludeInput && /*#__PURE__*/React.createElement("input", {
    id: ids === null || ids === void 0 ? void 0 : ids.input,
    name: name,
    type: "radio",
    disabled: interactiveStateCombined.disabled,
    style: inputStyle
  }), isNative && !platformDependentExcludeInput && /*#__PURE__*/React.createElement(Touchable, {
    accessible: true,
    accessibilityRole: "radio",
    accessibilityState: {
      disabled: interactiveStateCombined.disabled
    },
    disabled: interactiveStateCombined.disabled
  }, /*#__PURE__*/React.createElement(View, null)), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.overflowingCircle,
    style: overflowingCircleStyle
  }), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.solidColor,
    style: solidColorStyle
  }), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.border,
    style: borderStyle
  }), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.innerCircle,
    style: innerCircleStyle
  }));
};
RadioBullet.displayName = 'RadioBullet';
export default withProvisionalOverrideFromContext(RadioBullet);
//# sourceMappingURL=index.js.map